// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PartnerDetailsActionTypes from './partner-details.types';
import {
	partnerDetailsAdd,
	fetchPartnerDetails,
	updatePartnerDetails,
	deletePartnerDetails,
} from './partner-details.service';
import {
	addBusinessPartnerSuccess,
	addBusinessPartnerFailure,
	addBusinessPartnerResponseChanged,
	updateBusinessPartnerSuccess,
	updateBusinessPartnerFailure,
	updateBusinessPartnerResponseChanged,
	fetchBusinessPartnerSuccess,
	fetchBusinessPartnerFailure,
	fetchBusinessPartnerResponseChanged,
	deleteBusinessPartnerFailure,
	deleteBusinessPartnerSuccess,
	deleteBusinessPartnerResponseChanged,
} from './partner-details.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS PARTNER  ******************** */
export function* businessPartnerAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, partnerListArr } = payload;
		const key = 'BusinessPartnerKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			PartnerListArr: partnerListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(partnerDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessPartnerFailure(responseData.data));
		} else {
			yield put(addBusinessPartnerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessPartnerFailure(error));
	}
}

export function* resetAddBusinessPartnerResponse() {
	yield put(addBusinessPartnerResponseChanged());
}

export function* onAddBusinessPartnerDetails() {
	yield takeLatest(PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_START, businessPartnerAdd);
}

export function* onAddBusinessPartnerResponseReset() {
	yield takeLatest(
		PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_RESPONSE_RESET,
		resetAddBusinessPartnerResponse,
	);
}
/** *********************  END ADD BUSINESS PARTNER ******************** */

/** *********************  START UPDATE BUSINESS PARTNER  ******************** */
export function* businessPartnerUpdate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, partnerListArr } = payload;
		const key = 'UpdateBusinessPartnerKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			PartnerListArr: partnerListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updatePartnerDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessPartnerFailure(responseData.data));
		} else {
			yield put(updateBusinessPartnerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessPartnerFailure(error));
	}
}

export function* resetUpdateBusinessPartnerResponse() {
	yield put(updateBusinessPartnerResponseChanged());
}

export function* onUpdateBusinessPartnerDetails() {
	yield takeLatest(
		PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_START,
		businessPartnerUpdate,
	);
}

export function* onUpdateBusinessPartnerResponseReset() {
	yield takeLatest(
		PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_RESPONSE_RESET,
		resetUpdateBusinessPartnerResponse,
	);
}
/** *********************  END UPDATE BUSINESS PARTNER ******************** */

/** *********************  START FETCH BUSINESS PARTNER  ******************** */
export function* businessPartnerFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessPartnerKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchPartnerDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessPartnerFailure(responseData.data));
		} else {
			yield put(fetchBusinessPartnerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessPartnerFailure(error));
	}
}

export function* resetFetchBusinessPartnerResponse() {
	yield put(fetchBusinessPartnerResponseChanged());
}

export function* onFetchBusinessPartnerDetails() {
	yield takeLatest(PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_START, businessPartnerFetch);
}

export function* onFetchBusinessPartnerResponseReset() {
	yield takeLatest(
		PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_RESPONSE_RESET,
		resetFetchBusinessPartnerResponse,
	);
}
/** *********************  END FETCH BUSINESS PARTNER ******************** */

/** *********************  START DELETE BUSINESS PARTNER ******************** */
export function* businessPartnerDelete({ payload }: any) {
	try {
		const { businessPartnerID, companyID, databaseName } = payload;
		const key = 'DeleteBusinessPartnerKey';
		const jsonData = {
			BusinessPartnerID: businessPartnerID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deletePartnerDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessPartnerFailure(responseData.data));
		} else {
			yield put(deleteBusinessPartnerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessPartnerFailure(error));
	}
}

export function* resetDeleteBusinessPartnerResponse() {
	yield put(deleteBusinessPartnerResponseChanged());
}

export function* onDeleteBusinessPartnerDetails() {
	yield takeLatest(
		PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_START,
		businessPartnerDelete,
	);
}

export function* onDeleteBusinessPartnerResponseReset() {
	yield takeLatest(
		PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_RESPONSE_RESET,
		resetDeleteBusinessPartnerResponse,
	);
}
/** ********************* END DELETE BUSINESS PARTNER ******************** */

export function* partnerDetailsSaga() {
	yield all([
		call(onAddBusinessPartnerDetails),
		call(onAddBusinessPartnerResponseReset),
		call(onUpdateBusinessPartnerDetails),
		call(onUpdateBusinessPartnerResponseReset),
		call(onFetchBusinessPartnerDetails),
		call(onFetchBusinessPartnerResponseReset),
		call(onDeleteBusinessPartnerDetails),
		call(onDeleteBusinessPartnerResponseReset),
	]);
}
